import { render, staticRenderFns } from "./NLPComponent.vue?vue&type=template&id=857ce9a6&"
import script from "./NLPComponent.vue?vue&type=script&lang=js&"
export * from "./NLPComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports